<div class="sectionContainer paddedContent" style="margin: 10px">
  <div style="display: flex; gap: 20px; margin-bottom: 20px">
    <div>
      {{ user.fullName }}<br />
      {{ user.emailAddress }}<br />
    </div>
    <div>
      <!-- <app-button-input [icon]="'Key'" [text]="'Reset password'" /> -->
    </div>
  </div>

  <div [hidden]="!user.isSwipesumInternalUser">
    <h4>Settings</h4>

    <input type="radio" (click)="normalDebugging()" name="debug" />
    <label>Standard debugging</label>
    <br />
    <input type="radio" (click)="advancedDebugging()" name="debug" />
    <label>Advanced debugging</label>
    <br />
    <input type="radio" (click)="noDebugging()" name="debug" />
    <label>Disable debugging</label>
  </div>
</div>
